// extracted by mini-css-extract-plugin
module.exports = {"leftImg":"LeftImg-module--left-img--1QlRX","img":"LeftImg-module--img--5dF-0","content":"LeftImg-module--content--2N6zK"};